import React from 'react';
import PropTypes from 'prop-types';

import CtaButton from 'components/essentials/Cta/CtaButton';
import IconCustomize from 'components/icons/iconCustomize2';
import { colorBrand } from 'styles/layout/colors';

const PDPFreeSwatchKitButton = ({ onClick = () => {}, styling = 'link' }) => (
  <CtaButton
    styling={styling}
    color="brand"
    hasArrow={false}
    onClick={onClick}
    className="PDPFreeSwatchKitButton"
  >
    <span className="text-sm font-bold items-center text-brand flex hover:!underline">
      <IconCustomize
        color={colorBrand}
        height={16}
        width={22}
        className="!mr-2"
      />
      <span>Get a free swatch kit</span>
    </span>
  </CtaButton>
);

PDPFreeSwatchKitButton.propTypes = {
  onClick: PropTypes.func,
  styling: PropTypes.string,
};

export default PDPFreeSwatchKitButton;
